<session-analytic-item-view
  (onExpanded)="onExpanded.emit($event)"
  [isExpanded]="isExpanded"
  title="{{'session-analytics_feedback-graph' | translate}}"
  [dataSummary]="feedbackSummary">
  <div graph
    class="feedback-graph-container"
    role="application">
    @if (this.commentSeriesData.length || markerSeriesData.length) {
      <highcharts-chart
        #feedbackChart
        style="height: 200px; width: 100%;"
        [options]="chartOptions"
      ></highcharts-chart>
      @if (markerSeriesData.length > 0) {
        <marker-display [markers]="markersWithCount" [withCount]="true"></marker-display>
      }
    } @else {
      <analytic-graph-zero-state>
        {{'feedback-graph_zero-state' | translate}}
      </analytic-graph-zero-state>
    }

  </div>
</session-analytic-item-view>
